var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconGarage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2F1F19",
  d: "m21.36 7.344-9-5a.73.73 0 0 0-.73 0l-8.99 5c-.24.13-.39.38-.39.66v13c0 .41.34.75.75.75h18c.41 0 .75-.34.75-.75v-13a.77.77 0 0 0-.39-.66m-14.61 7.41h10.5v2.5H6.75zm10.5-1.5H6.75v-1.25c0-.14.11-.25.25-.25h10c.14 0 .25.11.25.25zm-10.5 7v-1.5h10.5v1.5zm13.5 0h-1.5v-8.25c0-.96-.79-1.75-1.75-1.75H7c-.96 0-1.75.79-1.75 1.75v8.25h-1.5V8.444L12 3.864l8.25 4.58z"
})));
export default SvgIconGarage;